import React from 'react'
import { PaidMarketingPlanWrapper } from 'Features/pricing/tabs/PaidMarketing/PaidMarketing.styled'
import { PlanBox } from 'Features/pricing/components/PlanBox/PlanBox'
import { useSelectPlan } from 'Features/pricing/hooks/useSelectPlan'
import { Plan } from 'Features/pricing/types/Plan'
import { PlansJson } from 'Types/Plan'
import { PLAN_TYPES, PlanTypes } from 'Types/PlansTypes'
import { CurrenciesTypes } from 'Types/Currencies'
import { ProductTypes } from 'Types/ProductTypes'

type PaidMarketingPlansDesktopProps = {
  numOfVisits: number
  plansDb: Array<Plan>
  plansJson: PlansJson
  productName: ProductTypes
  currency: CurrenciesTypes
  bundle?: boolean
  crossSell?: boolean
  selectedPlan?: PlanTypes
  setSelectedPlan?: (plan: PlanTypes) => void
  reactivation?: boolean
  billingCycleMonths?: number
  source: string
}

export const PricingPlansDesktop = ({
  numOfVisits,
  plansDb,
  plansJson,
  productName,
  currency,
  bundle,
  crossSell,
  selectedPlan,
  setSelectedPlan,
  reactivation,
  billingCycleMonths,
  source,
}: PaidMarketingPlansDesktopProps) => {
  const { planSelected, isLoading } = useSelectPlan(plansDb, productName, currency)
  const planOnClick = (value: PlanTypes) => {
    if (bundle || crossSell) {
      if (setSelectedPlan) setSelectedPlan(value)
    } else {
      planSelected({
        type: value,
        numOfVisits: numOfVisits,
        reactivation,
        billingCycleMonths,
      })
    }
  }

  const renderPlanBox = () => {
    return Object.entries(PLAN_TYPES).map(([key, value]) => {
      return (
        <PlanBox
          selectedPlan={selectedPlan}
          reactivation={reactivation}
          key={key}
          disableButton={isLoading}
          planName={value}
          bundle={bundle}
          crossSell={crossSell}
          plansJson={plansJson}
          productName={productName}
          plansDb={plansDb}
          numOfVisits={numOfVisits}
          currency={currency}
          onClick={() => {
            planOnClick(value)
          }}
          source={source}
        />
      )
    })
  }

  return (
    <PaidMarketingPlanWrapper crossSell={crossSell} bundle={bundle}>
      {renderPlanBox()}
    </PaidMarketingPlanWrapper>
  )
}
